module.exports = __webpack_public_path__ + "media/cd-helper.47e3fde2.mp4";